import React from "react";
import { ResetPassword } from "./ResetPassword";
import { Splash } from "./Splash";
export const SplashResetScreen = (props) => {
  let token = props.match.params.token;
  return !token ? <Splash/> : <ResetPassword token={token}/>;
};
